import LinkiaApiClient from '@interficie/linkia-api-client';
import config from './config';

export default (new LinkiaApiClient({ baseURL: config.apiBaseURL }));
